<template>
    <Pdf :doc="doc"></Pdf>
</template>
<script>
    import Pdf from "../components/Pdf";
    export default {
        components: {Pdf},
        mounted() {
            this.$store.commit('SET_TITLE', this.doc.title)
        },
        computed: {
            doc () {
                let docs = []
                this.$store.state.downloads.forEach((d) => {
                    docs.push(...d.children)
                })
                return docs.find((d) => {
                    return d.link === this.$route.params.name
                })
            }
        }
    }
</script>
